/* global swal angular */
import './style.less';

export default function($uibModalInstance, $log, ApiClass, certification) {
  'ngInject';
  try {
    const vm = this;
    vm.$onInit = activate;

    vm.close = item => $uibModalInstance.close(item);

    vm.formData = angular.copy(certification);

    vm.update = function() {
      vm.certificationUpdateBtn = true;
      vm.close(vm.formData);
      vm.certificationUpdateBtn = false;
    };

    function activate() {
      vm.formData = { ...certification };

      if (certification.issue_date) vm.formData.issue_date = new Date(certification.issue_date);
      if (certification.exp_date) vm.formData.exp_date = new Date(certification.exp_date);
    }
  } catch (error) {
    $log.error(error);
    throw error;
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/editCertification/index.js